import { Menu } from '@mui/icons-material'
import { AppBar, Box, Button, Chip, IconButton, Stack, Toolbar, useMediaQuery, useTheme } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { FormsActions, FormsSelector } from '../../store/forms'
import { ButtonIcon, SippLogo } from '../icons'
import { AddressSearchForm } from '../AddressSearchForm'
import { useNavigate } from 'react-router'
import { AppActions } from '../../store/app'


export const Header = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const formId = 'navigationSidebar'
  const formValues = useSelector((state: RootState) => FormsSelector.getFormValues(state, formId))
  const { open = false } = formValues

  const baseStyle = {
    height: 68,
    background: isMobile ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.9)',
    backdropFilter: isMobile ? 'blur(10px)' : undefined,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,

  }

  const handleDrawerToggle = () => {
    dispatch(FormsActions.setValue({ id: 'navigationSidebar', open: !open }))
  }
  const handleHIWModal = () => {
    dispatch(AppActions.toggleHowItWorksModalOpen())
  }
  return (
    <AppBar position="static" sx={baseStyle} elevation={0}>
      <Toolbar sx={{ py: 1, height: '100%' }}>
        <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            <IconButton aria-label="open drawer" onClick={handleDrawerToggle} edge="start">
              <Menu />
            </IconButton>
            <SippLogo sx={{ fontSize: isMobile ? '2.5rem' : '3rem', ml: isMobile ? 0 : 1 }} />
            <Chip
              label="Beta"
              sx={{
                backgroundColor: theme.palette.blue[100],
                color: '#003E63',
                borderColor: theme.palette.blue[200],
                border: '1px solid',
                fontWeight: 'medium',
                fontSize: '14px',
              }}
            />
          </Stack>

          {!isMobile && <AddressSearchForm />}
          {/* {!isMobile && <ZipCodeForm />} */}

          <IconButton
            onClick={handleHIWModal}
            sx={{
              py: 1,
              px: 1.5,
              mx: 1,
              width: 32,
              height: 32
            }}
          >
            ?
          </IconButton>
          <Button
            size="large"
            variant="contained"
            onClick={() => navigate('/landing')}
            startIcon={<ButtonIcon />}
            sx={{
              py: 1,
              px: 1.5,
            }}
          >
            Test your water
          </Button>

        </Stack>
      </Toolbar>
    </AppBar>
  )
}
